<a [routerLink]="['/live-lesson', lesson().id]" class="live-notification">
  <div class="notification-text">
    <span class="notification-title">
      <span class="live-status-dot">
        <span class="live-status-ring"></span>
      </span>
      Aaliyah is live now!
    </span>
    <span class="notification-subtitle">Join Aaliyah in a Live Lesson</span>
  </div>

  <span class="notification-cta">
    <span class="cta-ring-outer"></span>
    <span class="cta-button">
      <span class="material-symbols-outlined">arrow_forward</span>
    </span>
  </span>
</a>
